export const login = '/login'
export const registerSchool = '/register-school'
export const digiscanRoot = '/digiscan'
export const digiscan = '/digiscan/:schoolGeneratedId'
export const registerSchoolleader = '/registerschoolleader/:generatedId'

export const preregisterSchoolleaderRoot = '/schoolleader-signup'
export const preregisterSchoolleader = '/schoolleider-voorregistratie/:groupId'
export const schoolleaderSurvey = '/schoolleader-survey/:generatedId'
export const admin = '/admin'
export const unauthorized = '/unauthorized'

export const list = {
  anonymousSchoolleaders: '/admin/preregistered-schoolleaders',
  answers: '/admin/answers',
  dashboard: '/admin/dashboard',
  schoolleaderDashboard: '/admin/globale-verslaggeving',
  groups: '/admin/groups',
  forms: '/admin/forms',
  formAnswers: '/admin/form-answers',
  questions: '/admin/questions',
  reports: '/admin/reports',
  schools: '/admin/schools',
  schoolleaders: '/admin/schoolleaders',
  scholleaderReports: '/admin/schoolleaderReports',
  sessions: '/admin/sessions',
  statisticGroups: '/admin/statistic-groups',
  quicScanParticipants: '/admin/quickscan-participants',
}

export const create = {
  answer: '/admin/create-answer',
  multischoolReport: '/admin/create-multischool-report',
  form: '/admin/create-form',
  group: '/admin/create-group',
  question: '/admin/create-question',
  schoolleaderQuestion: '/admin/create-schoolleader-question',
  session: '/admin/create-session',
  schoolleader: '/admin/create-schoolleader',
  statisticGroups: '/admin/create-statistic-group',
}

export const view = {
  answer: '/admin/answers/:id',
  form: '/admin/forms/:id',
  formAnswers: '/admin/form-answers/:id',
  group: '/admin/groups/:id',
  question: '/admin/questions/:id',
  schoolleaderQuestion: '/admin/schoolleader-questions/:id',
  session: '/admin/sessions/:id',
  school: '/admin/schools/:id',
  research: {
    root: '/admin/research',
    uhasselt: '/admin/research/uhasselt',
  },
}
export const update = {
  answer: '/admin/answers/:id',
  form: '/admin/forms/:id',
  question: '/admin/questions/:id',
  school: '/admin/schools/:id/edit',
  schoolleader: '/admin/schoolleaders/:id',
  schoolleaderQuestion: '/admin/schoolleader-questions/:id',
  session: '/admin/sessions/:id',
  statisticGroup: '/admin/statistic-groups/:id',
}
